import React from 'react';
import './stylesheets/app.css';

import Hero from './components/Hero';
import Contact from './components/Contact';
import Experience from './components/Experience';

class App extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Hero />
        <Experience />
        <Contact />
      </React.Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js